import React from "react";
import { dictionary } from "helpers/Dictionary";
import "components/text/textStyle/textStyle.scss";
import _ from "lodash";

const localeLanguage = localStorage.getItem("localeLanguage");

const defaultLanguage = "en";

interface ILocaleCurrencyProps {
  currency?: string;
  amount?: number | string;
  locale?: string;
  style?: React.CSSProperties;
}

export function LocaleText(props: any) {
  return <span>{_.get(dictionary, [props.id, localeLanguage ? localeLanguage : defaultLanguage])}</span>;
}

export function LocaleCurrency(props: ILocaleCurrencyProps) {
  const { currency, style, amount } = props;
  let formattedAmount;
  if (amount != null) {
    const format = new Intl.NumberFormat(new Intl.NumberFormat().resolvedOptions().locale ?? "en-CA", {
      style: "currency",
      currency: currency?.toUpperCase() ?? "CAD",
      useGrouping: false,
    }).format(Number(amount));
    formattedAmount = format.replace(/[A-Za-z ]/g, "");
  }

  return <span style={style}>{formattedAmount ?? null}</span>;
}

export function LocaleCurrencyString(props: ILocaleCurrencyProps): string {
  const { currency, amount } = props;
  let formattedAmount;
  if (amount != null) {
    const format = new Intl.NumberFormat(new Intl.NumberFormat().resolvedOptions().locale ?? "en-CA", {
      style: "currency",
      currency: currency?.toUpperCase() ?? "CAD",
      useGrouping: false,
    }).format(Number(amount));
    formattedAmount = format.replace(/[A-Za-z ]/g, "");
  }

  return formattedAmount ?? null;
}

// Retrieve the default browser locale's being used by the user
export function getBrowserLocales(options = {}) {
  const defaultOptions = {
    languageCodeOnly: false,
  };

  const opt = {
    ...defaultOptions,
    ...options,
  };

  const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages;

  if (!browserLocales) {
    return undefined;
  }

  return browserLocales.map(locale => {
    const trimmedLocale = locale.trim();

    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
  });
}
